import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbbreviateNumberPipe } from 'src/app/core/pipes/abbreviate-number.pipe';
import { ActionState, TVDOpportunityModel } from 'src/app/features/action-center/types/action-center-types';
import { round } from 'lodash';

@Component({
    selector: 'app-tvd-box',
    templateUrl: './tvd-box.component.html',
    styleUrls: ['./tvd-box.component.scss'],
    providers: [AbbreviateNumberPipe],
    standalone: false
})
export class TvdBoxComponent implements OnInit, OnChanges {
  @Input() currPageState: ActionState | undefined;
  @Input() currentTVD: TVDOpportunityModel | undefined;
  @Input() opportunitiesTVD: TVDOpportunityModel | undefined;
  @Input() totalOpportunityTVD: number = 0;
  @Input() totalCurrentTVD: number = 0;
  @Input() tvdDeltaPercent: number = 0;

  currentValues: TVDOpportunityModel | undefined;
  carouselItems: {
    metricName: keyof TVDOpportunityModel,
    currentTVDValue: string,
    opportunityTVDValue: string,
    imgUrl: string
  }[] = [
      {
        metricName: 'Productivity',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_productivity_blue.png'
      },
      {
        metricName: 'Assets',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_assets.png'
      },
      {
        metricName: 'Employee Safety',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_safety_blue.png'
      },
      {
        metricName: 'Water',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_water_blue.png'
      },
      {
        metricName: 'Energy',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_energy_blue.png'
      },
      {
        metricName: 'Greenhouse Gases',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_greenhouse_gases.png'
      },
      {
        metricName: 'Plastic Waste',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_waste_blue.png'
      },
      {
        metricName: 'Cardboard Waste',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/tvd_icon_image_waste_blue.png'
      },
      {
        metricName: 'Cost Avoidance',
        currentTVDValue: '0',
        opportunityTVDValue: '0',
        imgUrl: 'assets/cost-avoidance.png'
      }
  ];

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
  };

  currentIndex: number = 0;

  constructor() {}

  get maxIndex(): number {
    return Math.max(0, this.carouselItems.length - this.slideConfig.slidesToShow);
  }

  // Window of items starting at currentIndex, wrapping around when infinite
  get visibleItems() {
    const total = this.carouselItems.length;
    const visibleCount = Math.min(this.slideConfig.slidesToShow, total);

    return Array.from({ length: visibleCount },
      (_, offset) => this.carouselItems[(this.currentIndex + offset) % total]);
  }

  prevSlide() {
    const total = this.carouselItems.length;
    const step = this.slideConfig.slidesToScroll;

    this.currentIndex = (this.currentIndex - step + total) % total;
  }

  nextSlide() {
    const total = this.carouselItems.length;
    const step = this.slideConfig.slidesToScroll;

    this.currentIndex = (this.currentIndex + step) % total;
  }

  trackByMetricName(_index: number, item: { metricName: string }) {
    return item.metricName;
  }

  ngOnInit() {
    this.setupData();
  }
  
  ngOnChanges(change: SimpleChanges) {
    this.setupData();
  }

  setupData() {
    // set up carouselItems with currentTVD and opportunitiesTVD
    if (this.currentTVD != undefined && this.opportunitiesTVD != undefined) {
      this.carouselItems.forEach((item) => {
        const metricName = item.metricName;
        item.currentTVDValue = this.currentTVD ? this.currentTVD[metricName] : '0';
        item.opportunityTVDValue = this.opportunitiesTVD ? this.opportunitiesTVD[metricName] : '0';
      });
    }
  }
}
